__turbopack_context__.v({
  "button": "not-found-module__HS70Aa__button",
  "card": "not-found-module__HS70Aa__card",
  "image": "not-found-module__HS70Aa__image",
  "subtitle": "not-found-module__HS70Aa__subtitle",
  "title": "not-found-module__HS70Aa__title",
  "wrapper": "not-found-module__HS70Aa__wrapper",
});
